__turbopack_context__.v({
  "ProductCardList__CategoryContainer": "YvF2aW_ProductCardList__CategoryContainer",
  "ProductCardList__CategoryGrid": "YvF2aW_ProductCardList__CategoryGrid",
  "ProductCardList__CategoryTitle": "YvF2aW_ProductCardList__CategoryTitle",
  "ProductCardList__Grid": "YvF2aW_ProductCardList__Grid",
  "ProductCardList__Grid--Accessory": "YvF2aW_ProductCardList__Grid--Accessory",
  "ProductCardList__Grid--Legacy": "YvF2aW_ProductCardList__Grid--Legacy",
});
